import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import * as React from "react";
import { AutoCompleteInput, Input, ItemCard, Label } from "uxp/components";
import { bindContainerId } from "../../../util";
import { IContextProvider } from "../../../uxp";
import { IUIPropertyDefinition, IWDDesignModeProps, PropertyPath } from "../../common/common";
import { CustomColorPicker } from "../../common/ui-props/common";
import { DataSourceProperty, DataSourcePropertyEditor } from "../../common/ui-props/DataSourceProperty";
import { IDataSource, IDataSourceBinding, schemaAtJsonPath } from "../data-source-picker/datasource";

export declare type ChartType = 'bar' | 'area' | 'line';

export interface IChartItem {
    binding: IDataSourceBinding;
    xTitle: string;
    yTitle: string;
    type: ChartType;
    field: string;
    label: string;
    color: string;
    unit: string;
}
export interface IChartResult {
    type: IChartItem;
    data: any[];
}

interface IChartItemProps {
    item: IChartItem;
    onChange: (item: IChartItem) => void;
    onDelete: () => void;
    sources: IDataSource[];
    uxpContext: IContextProvider;
    contextData: any;
    onChangeAny: (path: PropertyPath, value: any) => void;
    designer: IWDDesignModeProps;
    containerId?: string,
}
export function findAvailableFields(item: IChartItem, sources: IDataSource[], results: any) {
    let t = item.binding;
    let source = sources?.find(x => x.id == t?.source);
    if (source) {
        let path = item.binding?.path;

        let targetSchema = (schemaAtJsonPath(source.schema, path));
        if (targetSchema?.type == 'array') {
            if (targetSchema.items?.type == 'object') {
                let required = Object.keys(targetSchema.items?.properties || {});
                for (let r of required) {
                    results[r] = '1';
                }
            }
        }

    }
};
const ChartItem: React.FunctionComponent<IChartItemProps> = (props) => {
    console.log('chart-item-props ', props)
    let { item } = props;
    function onChange(field: string, value: any) {
        props.onChange({ ...item, [field]: value });
    }
    let dp = DataSourceProperty('Data Source', item.binding, props.sources, props.uxpContext, props.designer, null);
    let possibleValues = {};
    findAvailableFields(item, props.sources, possibleValues);
    let pv = Object.keys(possibleValues);
    pv.sort();
    return <div className='wd-chart-item'>
        <div className='wd-chart-item-title'>
            <div className='lbl'>{item.type + ' Chart'}</div>
            <div onClick={() => props.onDelete()} className='del'>-</div>
        </div>
        <div className='wd-chart-item-body'>
            <div className='wd-chart-item-field'>
                <div className='icon-tray'>
                    <div onClick={() => onChange('type', 'area')} className={classNames('faicon', { selected: item.type == 'area' })}>
                        <FontAwesomeIcon width={25} height={25} icon={'chart-area'} />
                    </div>
                    <div onClick={() => onChange('type', 'line')} className={classNames('faicon', { selected: item.type == 'line' })}>
                        <FontAwesomeIcon width={25} height={25} icon={'chart-line'} />
                    </div>
                    <div onClick={() => onChange('type', 'bar')} className={classNames('faicon', { selected: item.type == 'bar' })}>
                        <FontAwesomeIcon width={25} height={25} icon={'chart-bar'} />
                    </div>
                </div>
            </div>
            <div className='wd-chart-item-field'>
                <Label>Name</Label>

                <Input
                    value={item.label || ''}
                    onChange={s => onChange('label', s)}
                    className="widget-designer-input"
                />
            </div>
            <div className={`wd-chart-item-field wd-chart-item-field-wrapper-for-datasource-button wd-ui-property ${!item.binding ? bindContainerId('no-data-source', props.containerId) : ''}`}>
                <DataSourcePropertyEditor
                    binding={item.binding}
                    context={props.uxpContext}
                    className={'wd-chart-source'}
                    onChange={(binding) => onChange('binding', binding)}
                    onChangeAny={props.onChangeAny}
                    sources={props.sources}
                    target={'dictionary-array'}
                    title='Data Source'
                    contextData={props.contextData} //TODO
                    designer={props.designer}
                />
            </div>
            <div className='wd-chart-item-field'>
                <Label>Value Field</Label>

                <AutoCompleteInput
                    value={item.field || ''}
                    onChange={s => onChange('field', s)}
                    className="widget-designer-input"
                    options={pv}
                />
            </div>

            <div className='wd-chart-item-field'>
                <Label>Unit Field</Label>

                <AutoCompleteInput
                    value={item.unit || ''}
                    onChange={s => onChange('unit', s)}
                    className="widget-designer-input"
                    options={pv}
                />
            </div>

            <div className='wd-chart-item-field'>
                <CustomColorPicker contextData={props.contextData} color={item.color} onChange={(c) => onChange('color', c)} />
            </div>
        </div>
    </div>
};
export function ChartItemProperty(title: string, props: IChartItem[], sources: IDataSource[], context: IContextProvider, getContextData: () => any): IUIPropertyDefinition<IChartItem[]> {
    return {
        defaults: props,
        render: (props, uxpContext,  contextData, containerId) => {
            let items = (props.uiProps || []).slice();

            const datasources = props?.parentUIProps?.datasources || []
            function newItem() {
                items.push({
                    binding: null,
                    color: '#06f',
                    field: 'value',
                    label: '',
                    type: 'bar',
                    xTitle: '',
                    yTitle: '',
                    unit: ''
                });
                props.onChange(items);
            }

            function updateItem(index: number, item: IChartItem) {
                items[index] = item;
                props.onChange([...items]);
            }
            function deleteItem(index: number) {
                let x = [...items]
                x.splice(index, 1);
                props.onChange(x);
            }
            return <div className='wd-prop-item wd-ui-property chart-item' id={bindContainerId('chartItems', containerId)}>
                <div className='wd-prop-item-title'>
                    <div className='lbl'>{'Chart Elements'}</div>
                    <div onClick={() => newItem()} className='add'>+</div>
                </div>
                <div className='wd-prop-chart-items'>
                    {
                        items.map((item, i) => <ChartItem
                            key={i}
                            uxpContext={context}
                            contextData={getContextData()}
                            sources={datasources}
                            item={item}
                            onDelete={() => deleteItem(i)}
                            onChange={(item) => updateItem(i, item)}
                            onChangeAny={props.onChangeAny}
                            designer={props.designer}
                            containerId={containerId}
                        />)
                    }
                </div>

            </div>;
        }
    };
}